// @ts-strict-ignore
import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';
import {LinkNode} from 'common/components/breadcrumbs/types';

import {template} from './template';
import css from './index.inline.styl';

type WizardBreadcrumbsState = {
  selected: LinkNode;
};

type WizardBreadcrumbsAttrs = {
  breadcrumbs: LinkNode[];
};

type WizardBreadcrumbsJsxProps = {
  attrs: WizardBreadcrumbsAttrs;
};

export class WizardBreadcrumbs extends Component<WizardBreadcrumbsState, WizardBreadcrumbsAttrs> {
  static get attrsSchema(): AttrsSchema<WizardBreadcrumbsAttrs> {
    return {
      breadcrumbs: {type: `json`},
    };
  }
  get config() {
    return {
      css,
      template,
      useShadowDom: true,
      defaultState: {
        selected: null,
      },
      helpers: {
        handleNodeClicked: (node: LinkNode) => {
          this.dispatchEvent(new CustomEvent(`nodeClicked`, {detail: {node}}));
        },
      },
    };
  }
}

export const WizardBreadcrumbsEl = defineAndMakeJsxFactory<WizardBreadcrumbsJsxProps>(
  `wizard-breadcrumbs`,
  WizardBreadcrumbs,
);
export const WizardBreadcrumbsReact = panel2react<WizardBreadcrumbsJsxProps>(`wizard-breadcrumbs`, WizardBreadcrumbs);
